module.exports = __webpack_public_path__ + "28c398fb15e59c0d86eb01b042d8a1bc.jpeg";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/alt/create.jpeg
// module id = 725
// module chunks = 0